import React from 'react';

interface PrioritiseButtonProps {
    isPriority: boolean;
}

const PrioritiseButton: React.FC<PrioritiseButtonProps> = ({isPriority}) => {
    return (
        <span
            className={`mdi ${isPriority ? 'mdi-star text-warning' : 'mdi-star-outline text-white'}`}
            style={{
                fontSize: '1.2rem',
                padding: 0,
            }}
        />
    );
};

export default PrioritiseButton; 